import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import { useSelect } from '@calendly/ui/components/select';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { SETTINGS_SECTION } from 'features/settings_modal/constants';
import { useSettingsNavigation } from 'features/settings_modal/use_settings_navigation';
const containerCss = "cood20w";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const spacingCss = "s15f2ols";
const Spacing = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(spacingCss, props.className)} />;
});
const SingleState = () => {
  const {
    close
  } = useSelect();
  const {
    hrefForSettingsModalEntry
  } = useSettingsNavigation();
  const userUrl = hrefForSettingsModalEntry(SETTINGS_SECTION.adminPeople, '/app/admin/users', 'active_users');
  const inviteUrl = '/app/admin/invitations/new';
  return <Container>
      <Spacing>
        {I18n.t('publisher.event_types.scope_dropdown.organization.title')}
      </Spacing>
      <Spacing>
        {I18n.t('publisher.event_types.scope_dropdown.organization.description')}
      </Spacing>
      <Spacing>
        <Link as={RouterLink} to={userUrl} onClick={close}>
          {I18n.t('publisher.event_types.scope_dropdown.organization.learn_more')}
        </Link>
      </Spacing>
      <Link as={RouterLink} to={inviteUrl} onClick={close}>
        {I18n.t('publisher.title.add_seats')}
      </Link>
    </Container>;
};
export default SingleState;

require("./single_state.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./single_state.js");